module.exports = __webpack_public_path__ + "img/veste-cuir.751e95ed.svg";